(function () {
  function cleanParam(params, name, maxLength) {
    const value = params.get(name);
    return value ? value.trim().slice(0, maxLength) : '';
  }

  function addHiddenField(form, name, value) {
    if (!value || form.querySelector(`[name="${name}"]`)) return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.dataset.productEnquiryField = '';
    form.appendChild(input);
  }

  const params = new URLSearchParams(window.location.search);
  const piece = cleanParam(params, 'enquire_piece', 200);
  const rawProductUrl = cleanParam(params, 'enquire_url', 1000);

  if (!piece || !rawProductUrl) return;

  let productUrl;
  try {
    productUrl = new URL(rawProductUrl, window.location.origin);
  } catch (error) {
    return;
  }

  if (productUrl.origin !== window.location.origin || !productUrl.pathname.includes('/products/')) return;

  const details = [
    { label: 'Piece', field: 'contact[Piece]', value: piece },
    { label: 'Metal', field: 'contact[Selected metal]', value: cleanParam(params, 'enquire_metal', 200) },
    { label: 'Stone', field: 'contact[Selected stone]', value: cleanParam(params, 'enquire_stone', 200) },
    { label: 'Ring size', field: 'contact[Selected ring size]', value: cleanParam(params, 'enquire_size', 100) },
    { label: 'Hidden halo', field: 'contact[Selected hidden halo]', value: cleanParam(params, 'enquire_hidden_halo', 200) },
    { label: 'Displayed price', field: 'contact[Displayed price]', value: cleanParam(params, 'enquire_price', 100) },
    { label: 'Variant ID', field: 'contact[Variant ID]', value: cleanParam(params, 'enquire_variant_id', 100) },
    { label: 'Product link', field: 'contact[Product URL]', value: productUrl.href },
  ].filter((detail) => detail.value);

  document.querySelectorAll('form.contact-form__form').forEach((form) => {
    if (form.dataset.productEnquiryInitialised === 'true') return;
    form.dataset.productEnquiryInitialised = 'true';

    details.forEach((detail) => addHiddenField(form, detail.field, detail.value));

    const body = form.querySelector('[data-product-enquiry-body]');
    if (!body || body.value.trim()) return;

    const detailLines = details
      .filter((detail) => detail.label !== 'Variant ID')
      .map((detail) => `${detail.label}: ${detail.value}`);

    body.value = [
      "I'm enquiring about this piece:",
      '',
      ...detailLines,
      '',
      'My question:',
      '',
    ].join('\n');
  });
})();
